(function () {
	const initSlider = () => {
		let productSlider;
		
		// Gestion des anciens sliders (existants)
		const productSliders = document.querySelectorAll('.swiper-product-slider');
		productSliders.forEach((slider, index) => {
			productSlider = new Swiper(slider, {
				slidesPerView: 1,
				pagination: {
					el: '.swiper-pagination',
					bulletClass: 'swiper-bullet',
					bulletActiveClass: 'swiper-bullet-active',
					clickable: true,
					renderBullet: function(index, className) {
						return '<span class="' + className + ' swiper-bullet--svg-animation"><svg width="30" height="30" viewBox="0 0 28 28"><circle class="svg__circle" style="animation-duration: ' + this.el.getAttribute('data-duration') + 's" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle></svg></span>';
					}
				},
				loop: true,
				loopAdditionalSlides: 1,
watchSlidesProgress: true,
centeredSlides: true,
				autoplay: {
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				},
				breakpoints: {
					1200: {
						direction: 'vertical'
					}
				},
				on: {
					slideChange: function() {
						this.pagination.render();
						this.pagination.update();
					}
				}
			});
		});

		// Gestion des nouveaux sliders produits (avec nos nouvelles fonctionnalités)
		const newProductSliders = document.querySelectorAll('.products-slider .carousel__slider');
		newProductSliders.forEach(slider => {
			const autoplayEnabled = slider.dataset.autoplay === 'true';
			const autoplayDelay = parseInt(slider.dataset.autoplayDelay) * 1000; // Convertir en millisecondes
			
			// Configuration de base
			const swiperConfig = {
				oop: true,
  rewind: true,
				slidesPerView: 1,
				spaceBetween: 20,
				navigation: {
					nextEl: slider.querySelector('.swiper-button-next'),
					prevEl: slider.querySelector('.swiper-button-prev'),
				},
				breakpoints: {
					576: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					990: {
						slidesPerView: 3,
						spaceBetween: 30,
					},
					1360: {
						slidesPerView: 4,
						spaceBetween: 30,
					}
				}
			};
			
			// Ajouter l'autoplay si activé
			if (autoplayEnabled && autoplayDelay > 0) {
				swiperConfig.autoplay = {
					delay: autoplayDelay,
					disableOnInteraction: false, // Continue l'autoplay après interaction
					pauseOnMouseEnter: true // Pause au survol
				};
			}
			
			// Initialiser Swiper
			new Swiper(slider, swiperConfig);
		});
	};

	const destroySlider = () => {
		// Détruire les anciens sliders
		const productSliders = document.querySelectorAll('.swiper-product-slider');
		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
		
		// Détruire les nouveaux sliders
		const newProductSliders = document.querySelectorAll('.products-slider .carousel__slider');
		newProductSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.product-slider-section, .products-slider');
		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
		});
		destroySlider();
		initSlider();
		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	initSection();
	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();